module.exports = __webpack_public_path__ + "static/media/FootwayOpen.9047a282.pdf";